import styled, { css } from 'styled-components';

import { ExternalLink } from 'components/external-link';
import { Link } from 'components/link';

import { theme } from './theme';

export const MAX_CAROUSEL_WIDTH = 1600;

export const CarouselContainer = styled.div<{ $topInset: number }>`
  position: relative;
  background-color: ${p => p.theme.token('main-menu-carousel-background')};
  padding: 0 96px;
  margin-block-start: ${p => p.$topInset}px;
  margin-block-end: 2px;

  ${Styles.mobile} {
    display: none;
  }

  .slider {
    position: relative;
    max-width: ${MAX_CAROUSEL_WIDTH}px;

    .slider-frame .slider-list {
      margin: 1px 0 !important;
    }
  }
`;

const tileStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${Styles.fontFamily.base};
  padding-block-start: 1.3rem;
  padding-block-end: 1rem;
  padding-inline: 0;
`;

export const TileExternal = styled(ExternalLink)`
  ${tileStyles}
  text-decoration: none;
`;

export const TileWithoutCurrent = styled(Link)`
  ${tileStyles}
`;

export const Tile = styled(TileWithoutCurrent)`
  &[aria-current='page'] * {
    color: ${Styles.color.navLinkColor.active};

    &::before {
      content: '';
      background-color: ${Styles.color.navLinkColor.active};
      height: 2px;
      position: absolute;
      inset-block-end: 0;
      inset-inline-start: 0;
    }
  }
`;

export const TileImageWrapper = styled.div`
  border-radius: 10px;
  margin: 0 auto;
  width: 80%;
  overflow: hidden;
  margin-block-end: 0.5rem;
  text-align: center;

  > img {
    height: 45px;
  }
`;

export const TileLabel = styled(Link)`
  font-size: ${theme.fontSize};
  text-align: center;
`;

export const TileButton = styled.button`
  ${tileStyles};

  background: transparent;
  border: none;
  cursor: pointer;
  width: 100%;
`;
